// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3Ckmx","vLegacy":"SelectSecondary_vLegacy__2CnRJ","error":"SelectSecondary_error__1F4XF","disabled":"SelectSecondary_disabled__LbPNn"};